import React, { useState } from "react"
import { useParams, useNavigate, Link } from "react-router-dom"
import { useSelector } from "react-redux"
import { selectUser } from "store/features/auth/authSlice"
import { toast } from "sonner"
import Breadcrumb from "components/Common/Breadcrumb"
import DashboardLoader from "components/Loader/DashboardLoader"
import { useGetMoneyReceiptByIdQuery } from "store/features/invoice/moneyReceiptApi"
import logoImg from "../../assets/images/logo-sm.png"

const ViewMoneyReceipt = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const user = useSelector(selectUser)

  const { data: receipt, isLoading } = useGetMoneyReceiptByIdQuery(id)
  const [isSending, setIsSending] = useState(false)
  const [showModal, setShowModal] = useState(false)

  // Format currency
  // const formatCurrency = amount => {
  //   return `BDT ${Math.round(amount).toLocaleString()}`
  // }

  // Format currency with currency code from receipt data
  const formatCurrency = (amount, currencyCode = null) => {
    const useCurrency = currencyCode || receiptData?.currency || "BDT"
    const formattedAmount = Math.round(amount).toLocaleString()

    switch (useCurrency) {
      case "USD":
        return `USD ${formattedAmount}`
      case "CAD":
        return `CAD ${formattedAmount}`
      case "EURO":
        return `EURO ${formattedAmount}`
      default:
        return `BDT ${formattedAmount}`
    }
  }

  // Format date
  const formatDate = dateString => {
    if (!dateString) return ""
    const date = new Date(dateString)
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  // Generate email HTML from saved receipt data
  const generateEmailHTML = () => {
    const receiptData = receipt?.receipt_data || {}
    const projectInfo = receipt?.project_info || {}

    return `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Money Receipt</title>

<style>
@media only screen and (max-width:600px){
  .stack-column{
    display:block !important;
    width:100% !important;
    padding:0 !important;
    margin-bottom:8px !important;
  }
  .stack-center{
    display:block !important;
    width:100% !important;
    text-align:center !important;
    padding:0 !important;
    margin-bottom:10px;
  }
  .stack-left{
    display:block !important;
    width:100% !important;
    text-align:left !important;
    padding-top:10px !important;
  }
}
</style>
</head>

<body style="margin:0;padding:0;background:#eef2f7;font-family:Arial,sans-serif;">

<table width="100%" cellpadding="0" cellspacing="0" style="padding:20px;">
<tr>
<td align="center">

<table width="100%" style="max-width:900px;background:#fff;border-radius:16px;overflow:hidden;">

<!-- HEADER -->
<tr>
<td style="background:linear-gradient(135deg,#1e3a8a,#2563eb);color:white;padding:20px;">
<table width="100%">
<tr>
<td class="stack-center" width="80" align="center">
  <img src="https://res.cloudinary.com/dlaeldpqy/image/upload/v1777306544/logo-sm_ubs6bx.png"
       width="60"
       style="display:block;margin:0 auto;">
</td>
<td class="stack-center">
  <h1 style="margin:0;font-size:24px;">MONEY RECEIPT</h1>
  <p style="margin:3px 0;font-size:12px;">Qwik IT Services</p>
</td>
<td class="stack-left" align="right" style="font-size:12px;">
  <p><strong>Receipt No:</strong> ${receipt?.receipt_no || ""}</p>
  <p><strong>Date:</strong> ${formatDate(receiptData?.receiptDate)}</p>
</td>
</tr>
</table>
</td>
</tr>

<!-- CONTENT -->
<tr>
<td style="padding:20px;">

<!-- INFO GRID -->
<table width="100%">
<tr>
<td class="stack-column" width="50%" style="padding-right:10px;vertical-align:top;">
<table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
<tr>
<td style="padding:16px;">
<h3 style="margin:0 0 10px;color:#1e3a8a;">Received From</h3>
<p><strong>${receiptData?.clientName || "-"}</strong></p>
<p>${receiptData?.clientAddress || "-"}</p>
<p>${receiptData?.clientPhone || "-"}</p>
<p>${receiptData?.clientEmail || "-"}</p>
<p style="height: 20px"></p>
</td>
</tr>
</table>
</td>
<td class="stack-column" width="50%" style="padding-left:10px;vertical-align:top;">
<table width="100%" style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
<tr>
<td style="padding:16px;">
<h3 style="margin:0 0 10px;color:#1e3a8a;">Qwik IT Services</h3>
<p><strong>Head Office:</strong> ${receiptData?.companyHeadOffice || ""}</p>
<p><strong>Bangladesh Office:</strong> ${
      receiptData?.companyBangladeshOffice || ""
    }</p>
<p><strong>Phone:</strong> ${receiptData?.companyPhoneBD || ""}, ${
      receiptData?.companyPhoneCanada || ""
    }</p>
<p><strong>Support:</strong> ${receiptData?.companyEmail || ""}</p>
<p><strong>Billing:</strong> billing@qwikit.ca}</p>
</td>
</tr>
</table>
</td>
</tr>
</table>

<!-- TABLE -->
<table width="100%" style="margin-top:20px;border-collapse:collapse;">
<tr style="background:#1e3a8a;color:white;">
<th style="padding:10px;text-align:left;">Description</th>
<th style="padding:10px;text-align:left;">Details</th>
</tr>
<tr>
<td style="padding:10px;border-bottom:1px solid #eee;"><strong>Project</strong></td>
<td style="padding:10px;border-bottom:1px solid #eee;">${
      projectInfo?.projectName || "-"
    }</td>
</tr>
<tr>
  <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Total Amount</strong></td>
  <td style="padding:10px;border-bottom:1px solid #eee;">${formatCurrency(
    receiptData?.totalAmount,
    receiptData?.currency
  )}</td>
</tr>
<tr>
  <td style="padding:10px;border-bottom:1px solid #eee;"><strong>New Received Amount</strong></td>
  <td style="padding:10px;border-bottom:1px solid #eee;color:#16a34a;">${formatCurrency(
    receiptData?.receivedAmount,
    receiptData?.currency
  )}</td>
</tr>
<tr>
  <td style="padding:10px 12px; border-bottom:1px solid #eee; font-size:13px;">
    <strong>Total Received Amount</strong>
  </td>
  <td style="padding:10px 12px; border-bottom:1px solid #eee; font-size:13px; color:#16a34a; font-weight:bold;">
    ${formatCurrency(
      receiptData?.totalReceivedAmount || receiptData?.receivedAmount,
      receiptData?.currency
    )}
  </td>
</tr>

<tr>
  <td style="padding:10px;border-bottom:1px solid #eee;"><strong>Remaining Amount</strong></td>
  <td style="padding:10px;border-bottom:1px solid #eee;color:#dc2626;">${formatCurrency(
    receiptData?.remainingAmount,
    receiptData?.currency
  )}</td>
</tr>
<tr>
<td style="padding:10px;border-bottom:1px solid #eee;"><strong>Payment Method</strong></td>
<td style="padding:10px;border-bottom:1px solid #eee;">${
      receiptData?.paymentMethod || "-"
    }</td>
</tr>
</table>

<!-- SUMMARY -->
<table width="100%" style="margin-top:20px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:12px;">
<tr>
  <td style="padding:10px;">Total Amount</td>
  <td align="right" style="padding:10px;">${formatCurrency(
    receiptData?.totalAmount,
    receiptData?.currency
  )}</td>
</tr>
<tr>
<td style="padding:10px;">Received Amount</td>
<td align="right" style="padding:10px;color:#16a34a;">${formatCurrency(
      receiptData?.receivedAmount,
      receiptData?.currency
    )}</td>
</tr>

<tr>
<td style="padding:10px;">Total Received Amount</td>
<td align="right" style="padding:10px;color:#16a34a;">${formatCurrency(
      receiptData?.totalReceivedAmount || receiptData?.receivedAmount,
      receiptData?.currency
    )}</td>
</tr>

<tr>
<td style="padding:10px;">Remaining Amount</td>
<td align="right" style="padding:10px;color:#dc2626;">${formatCurrency(
      receiptData?.remainingAmount,
      receiptData?.currency
    )}</td>
</tr>
</table>

<!-- STATUS -->
<table width="100%" style="margin-top:20px;text-align:center;">
<td style="padding:16px;
background:${
      receipt?.payment_status === "PAID IN FULL"
        ? "#ecfdf5"
        : receipt?.payment_status === "PLEASE COMPLETE THE PENDING PAYMENT"
        ? "#fffbeb"
        : "#fef2f2"
    };
border-left:5px solid ${
      receipt?.payment_status === "PAID IN FULL"
        ? "#16a34a"
        : receipt?.payment_status === "PLEASE COMPLETE THE PENDING PAYMENT"
        ? "#f97316"
        : "#dc2626"
    };">
<p>Payment Status</p>
<h2 style="margin:10px 0; color:${
      receipt?.payment_status === "PAID IN FULL"
        ? "#16a34a"
        : receipt?.payment_status === "PLEASE COMPLETE THE PENDING PAYMENT"
        ? "#f97316"
        : "#dc2626"
    }">
${receipt?.payment_status || "PENDING"}
</h2>
${
  receipt?.payment_status === "PLEASE COMPLETE THE PENDING PAYMENT"
    ? `<p style="margin:8px 0 0 0; font-size:14px;">${formatCurrency(
        receiptData?.remainingAmount,
        receiptData?.currency
      )} Remaining</p>`
    : ""
}
</td>
</table>

</td>
</tr>

<!-- FOOTER -->
<tr>
<td style="text-align:center;padding:20px;background:#f3f4f6;">
<p>Thank you for your payment!</p>
<p>We appreciate your trust in Qwik IT Services</p>
</td>
</tr>

</table>

</td>
</tr>
</table>

</body>
</html>
`
  }

  // Function to send email only
  const sendEmailOnly = async recipientEmail => {
    const emailHTML = generateEmailHTML()

    const response = await fetch(
      "https://resend-server.qwikit.ca/api/send-invoice",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: recipientEmail,
          subject: `Money Receipt #${receipt?.receipt_no} - Qwik IT Services`,
          html: emailHTML,
          invoiceNo: receipt?.receipt_no,
          clientName: receipt?.receipt_data?.clientName,
        }),
      }
    )

    return response.json()
  }

  // Handle Send Only
  const handleSendOnly = async () => {
    const recipientEmail = receipt?.sent_to

    if (!recipientEmail) {
      toast.error("Client email is required to send receipt")
      return
    }

    try {
      setIsSending(true)

      const emailData = await sendEmailOnly(recipientEmail)

      if (emailData.success) {
        toast.success(
          `Money Receipt #${receipt?.receipt_no} resent successfully to ${recipientEmail}`
        )
        setShowModal(false)
      } else {
        throw new Error(emailData.error || "Failed to send receipt")
      }
    } catch (error) {
      console.error("Error sending receipt:", error)
      toast.error("Failed to send receipt. Please try again.")
    } finally {
      setIsSending(false)
    }
  }

  // Open modal before sending
  const openSendModal = () => {
    setShowModal(true)
  }

  if (isLoading) {
    return <DashboardLoader />
  }

  if (!receipt) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="alert alert-danger">Money receipt not found</div>
          <Link to="/all-money-receipt" className="btn btn-primary">
            Back to Money Receipts
          </Link>
        </div>
      </div>
    )
  }

  const receiptData = receipt?.receipt_data || {}
  const projectInfo = receipt?.project_info || {}

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb
          title="Money Receipt"
          breadcrumbItem={`Receipt #${receipt?.receipt_no}`}
        />

        {/* Action Buttons */}
        <div className="row mb-4 no-print">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <Link to="/all-money-receipt" className="btn btn-secondary">
                <i className="fas fa-arrow-left me-1"></i> Back to Money
                Receipts
              </Link>
              <button
                type="button"
                className="btn btn-success"
                onClick={openSendModal}
                disabled={isSending}
              >
                <i className="fas fa-envelope me-1"></i>
                {isSending ? "Sending..." : "Resend Receipt to Client"}
              </button>
            </div>
          </div>
        </div>

        {/* Money Receipt Preview */}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title mb-3 text-center">
                  Money Receipt Preview
                </h5>
                <div
                  className="receipt"
                  style={{
                    maxWidth: "1000px",
                    margin: "0 auto",
                    background: "#fff",
                    borderRadius: "16px",
                    overflow: "hidden",
                    boxShadow: "0 20px 50px rgba(0,0,0,0.08)",
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      background: "linear-gradient(135deg, #1e3a8a, #2563eb)",
                      color: "white",
                      padding: "20px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "10px",
                          background: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "8px",
                          border: "1px dashed rgba(255,255,255,0.6)",
                        }}
                      >
                        <img
                          src={logoImg}
                          alt="Qwik IT"
                          style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <div>
                        <h1
                          style={{
                            margin: 0,
                            fontSize: "24px",
                            letterSpacing: "1px",
                          }}
                        >
                          MONEY RECEIPT
                        </h1>
                        <p
                          style={{
                            margin: "3px 0",
                            fontSize: "12px",
                            opacity: 0.9,
                          }}
                        >
                          Qwik IT Services
                        </p>
                      </div>
                    </div>
                    <div>
                      <p style={{ margin: "4px 0", fontSize: "12px" }}>
                        <strong>Receipt No:</strong> {receipt?.receipt_no}
                      </p>
                      <p style={{ margin: "4px 0", fontSize: "12px" }}>
                        <strong>Date:</strong>{" "}
                        {formatDate(receiptData?.receiptDate)}
                      </p>
                    </div>
                  </div>

                  {/* Content */}
                  <div style={{ padding: "20px" }}>
                    {/* Info Grid */}
                    <div
                      style={{
                        display: "flex",
                        gap: "16px",
                        flexWrap: "wrap",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          minWidth: "250px",
                          background: "#f9fafb",
                          border: "1px solid #e5e7eb",
                          padding: "16px",
                          borderRadius: "12px",
                        }}
                      >
                        <h3
                          style={{
                            marginTop: 0,
                            marginBottom: "12px",
                            color: "#1e3a8a",
                            fontSize: "16px",
                          }}
                        >
                          Received From
                        </h3>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>{receiptData?.clientName || "-"}</strong>
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          {receiptData?.clientAddress || "-"}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          {receiptData?.clientPhone || "-"}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          {receiptData?.clientEmail || "-"}
                        </p>
                      </div>

                      <div
                        style={{
                          flex: 1,
                          minWidth: "250px",
                          background: "#f9fafb",
                          border: "1px solid #e5e7eb",
                          padding: "16px",
                          borderRadius: "12px",
                        }}
                      >
                        <h3
                          style={{
                            marginTop: 0,
                            marginBottom: "12px",
                            color: "#1e3a8a",
                            fontSize: "16px",
                          }}
                        >
                          Qwik IT Services
                        </h3>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Head Office:</strong>{" "}
                          {receiptData?.companyHeadOffice || ""}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Bangladesh Office:</strong>{" "}
                          {receiptData?.companyBangladeshOffice || ""}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Phone:</strong>{" "}
                          {receiptData?.companyPhoneBD || ""},{" "}
                          {receiptData?.companyPhoneCanada || ""}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Support:</strong>{" "}
                          {receiptData?.companyEmail || ""}
                        </p>
                        <p style={{ margin: "6px 0", fontSize: "13px" }}>
                          <strong>Billing:</strong>{" "}
                          {/* {receiptData?.companyWebsite || ""} */}
                          billing@qwikit.ca
                        </p>
                      </div>
                    </div>

                    {/* Table */}
                    <div style={{ overflowX: "auto", marginBottom: "20px" }}>
                      <table
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr style={{ background: "#1e3a8a", color: "white" }}>
                            <th
                              style={{
                                padding: "10px 12px",
                                textAlign: "left",
                                fontSize: "13px",
                              }}
                            >
                              Description
                            </th>
                            <th
                              style={{
                                padding: "10px 12px",
                                textAlign: "left",
                                fontSize: "13px",
                              }}
                            >
                              Details
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            >
                              <strong>Project</strong>
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            >
                              {projectInfo?.projectName || "-"}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            >
                              <strong>Total Amount</strong>
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            >
                              {formatCurrency(
                                receiptData?.totalAmount,
                                receiptData?.currency
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            >
                              <strong>Received Amount</strong>
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                                color: "#16a34a",
                                fontWeight: "bold",
                              }}
                            >
                              {formatCurrency(
                                receiptData?.receivedAmount,
                                receiptData?.currency
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            >
                              <strong>Total Received Amount</strong>
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                                color: "#16a34a",
                                fontWeight: "bold",
                              }}
                            >
                              {formatCurrency(
                                receiptData?.totalReceivedAmount ||
                                  receiptData?.receivedAmount,
                                receiptData?.currency
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            >
                              <strong>Remaining Amount</strong>
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                                color: "#dc2626",
                                fontWeight: "bold",
                              }}
                            >
                              {formatCurrency(
                                receiptData?.remainingAmount,
                                receiptData?.currency
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            >
                              <strong>Payment Method</strong>
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            >
                              {receiptData?.paymentMethod || "-"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Summary */}
                    <div
                      style={{
                        background: "#f9fafb",
                        padding: "16px",
                        borderRadius: "12px",
                        border: "1px solid #e5e7eb",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "6px 0",
                        }}
                      >
                        <span>Total Amount</span>
                        <span>
                          {formatCurrency(
                            receiptData?.totalAmount,
                            receiptData?.currency
                          )}
                        </span>
                      </div>
                      {/* <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "6px 0",
                        }}
                      >
                        <span>Received Amount</span>
                        <span style={{ color: "#16a34a", fontWeight: "bold" }}>
                          {formatCurrency(receiptData?.receivedAmount)}
                        </span>
                      </div> */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "6px 0",
                        }}
                      >
                        <span>New Received Amount</span>
                        <span style={{ color: "#16a34a", fontWeight: "bold" }}>
                          {formatCurrency(
                            receiptData?.receivedAmount,
                            receiptData?.currency
                          )}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "6px 0",
                        }}
                      >
                        <span>Total Received Amount</span>
                        <span style={{ color: "#16a34a", fontWeight: "bold" }}>
                          {formatCurrency(
                            receiptData?.totalReceivedAmount ||
                              receiptData?.receivedAmount,
                            receiptData?.currency
                          )}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "6px 0",
                        }}
                      >
                        <span>Remaining Amount</span>
                        <span style={{ color: "#dc2626", fontWeight: "bold" }}>
                          {formatCurrency(
                            receiptData?.remainingAmount,
                            receiptData?.currency
                          )}
                        </span>
                      </div>
                    </div>

                    {/* Status */}
                    {/* <div
                      style={{
                        padding: "16px",
                        borderRadius: "12px",
                        background:
                          receipt?.payment_status === "PAID IN FULL"
                            ? "#ecfdf5"
                            : receipt?.payment_status ===
                              "PLEASE COMPLETE THE PENDING PAYMENT"
                            ? "#fffbeb"
                            : "#fef2f2",
                        borderLeft: `4px solid ${
                          receipt?.payment_status === "PAID IN FULL"
                            ? "#16a34a"
                            : receipt?.payment_status ===
                              "PLEASE COMPLETE THE PENDING PAYMENT"
                            ? "#f97316"
                            : "#dc2626"
                        }`,
                        textAlign: "center",
                      }}
                    >
                      <p style={{ margin: 0 }}>Payment Status</p>
                      <h2
                        style={{
                          margin: "10px 0",
                          fontSize: "20px",
                          color:
                            receipt?.payment_status === "PAID IN FULL"
                              ? "#16a34a"
                              : receipt?.payment_status ===
                                "PLEASE COMPLETE THE PENDING PAYMENT"
                              ? "#f97316"
                              : "#dc2626",
                        }}
                      >
                        {receipt?.payment_status || "PENDING"}{" "}
                        {receipt?.payment_status === "PAID IN FULL"
                          ? "✔"
                          : receipt?.payment_status ===
                            "PLEASE COMPLETE THE PENDING PAYMENT"
                          ? "⚠"
                          : "⏳"}
                      </h2>
                    </div> */}
                    <div
                      style={{
                        padding: "16px",
                        borderRadius: "12px",
                        background:
                          receipt?.payment_status === "PAID IN FULL"
                            ? "#ecfdf5"
                            : receipt?.payment_status ===
                              "PLEASE COMPLETE THE PENDING PAYMENT"
                            ? "#fffbeb"
                            : "#fef2f2",
                        borderLeft: `4px solid ${
                          receipt?.payment_status === "PAID IN FULL"
                            ? "#16a34a"
                            : receipt?.payment_status ===
                              "PLEASE COMPLETE THE PENDING PAYMENT"
                            ? "#f97316"
                            : "#dc2626"
                        }`,
                        textAlign: "center",
                      }}
                    >
                      <p style={{ margin: 0 }}>Payment Status</p>
                      <h2
                        style={{
                          margin: "10px 0",
                          fontSize: "20px",
                          color:
                            receipt?.payment_status === "PAID IN FULL"
                              ? "#16a34a"
                              : receipt?.payment_status ===
                                "PLEASE COMPLETE THE PENDING PAYMENT"
                              ? "#f97316"
                              : "#dc2626",
                        }}
                      >
                        {receipt?.payment_status || "PENDING"}
                      </h2>
                      {receipt?.payment_status ===
                        "PLEASE COMPLETE THE PENDING PAYMENT" && (
                        <p style={{ margin: "8px 0 0 0", fontSize: "14px" }}>
                          {formatCurrency(
                            receiptData?.remainingAmount,
                            receiptData?.currency
                          )}{" "}
                          Remaining
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Footer */}
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      background: "#f3f4f6",
                      fontSize: "12px",
                      color: "#555",
                    }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        marginBottom: "8px",
                      }}
                    >
                      Thank you for your payment!
                    </p>
                    <p style={{ margin: 0 }}>
                      We appreciate your trust in Qwik IT Services
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons Bottom */}
        <div className="row mt-4 mb-4 no-print">
          <div className="col-12">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-success"
                onClick={openSendModal}
                disabled={isSending}
              >
                <i className="fas fa-envelope me-1"></i>
                {isSending ? "Sending..." : "Resend Receipt to Client"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Send Options */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "400px",
              padding: "24px",
              position: "relative",
              boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                color: "#666",
              }}
            >
              ✕
            </button>

            <h3
              style={{ marginTop: 0, marginBottom: "20px", color: "#1e3a8a" }}
            >
              Resend Money Receipt
            </h3>

            <p style={{ marginBottom: "24px", color: "#555" }}>
              Send this receipt to {receipt?.sent_to}?
            </p>

            <button
              onClick={handleSendOnly}
              disabled={isSending}
              style={{
                width: "100%",
                padding: "12px",
                marginBottom: "12px",
                backgroundColor: "#2563eb",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: isSending ? "not-allowed" : "pointer",
                opacity: isSending ? 0.6 : 1,
              }}
            >
              {isSending ? "Sending..." : "Send Receipt"}
            </button>

            <button
              onClick={() => setShowModal(false)}
              disabled={isSending}
              style={{
                width: "100%",
                padding: "12px",
                marginTop: "12px",
                backgroundColor: "#f3f4f6",
                color: "#374151",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "14px",
                cursor: isSending ? "not-allowed" : "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ViewMoneyReceipt
